import styled from 'styled-components';
import Heading from 'components/Heading';

export const HeaderMargin = styled(Heading)`
  margin-bottom: ${props =>
    props.marginBottom ? props.theme.spacing.default : 0};
`;
